<style lang="scss">

#app {
    // margin-top:30px;
}

.content {
    margin-top: 30px;
}

.main-container {
  min-height:500px;
}

.slogan-wrapper {
    width: 200px;
}

.slogan {
    font-size: 8pt;
}

footer {
  margin-top:30px;
}

// Transition
// .page-enter-active, .page-leave-active {
//   transition: opacity 0.25s, transform 0.25s;
// }
// .page-enter, .page-leave-to {
//   opacity: 0;
//   transform: translateX(-30%);
// }

</style>

<template>

<div id="app">

    <nav class="navbar is-fixed-top is-info" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <div class="navbar-item">
                <img src="./assets/logo.png">
            </div>
            <div class="navbar-item slogan-wrapper">
                <small class="slogan">Market intelligence<br />for SaaS entrepreneurs</small>
            </div>
            <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>

        <div id="navbarBasicExample" class="navbar-menu">
            <div class="navbar-start">
                <router-link to="/" class="navbar-item" active-class="is-active" exact>
                    Home
                </router-link>

                <router-link to="/categories" class="navbar-item" active-class="is-active" exact>
                    <b-icon icon="shape" size="is-small" />&nbsp;&nbsp;Categories
                </router-link>
                <router-link to="/products" class="navbar-item" active-class="is-active" exact>
                    <b-icon icon="apps" size="is-small" />&nbsp;&nbsp;Products
                </router-link>


            </div>

            <div class="navbar-end">
                <div class="navbar-item">
                    <div class="buttons">
                        <b-button type="is-info" @click="isHelpModalActive = true" icon-left="help-circle-outline">
                            Help
                        </b-button>

                        <!-- <a class="button is-primary">
            <strong>Sign up</strong>
          </a> -->
                        <a class="button is-light">
            Log out
          </a>
                    </div>
                </div>
            </div>
        </div>
    </nav>


    <div class="container main-container">
        <div class="content">
            <transition name="page" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
    </div>

    <footer class="footer">
  <div class="content has-text-centered">
    <p>
      <strong>SaaS Instinct</strong> by <a href="http://www.google.com">SMTC</a>
    </p>
  </div>
</footer>



    <b-modal :active.sync="isHelpModalActive" :width="640" scroll="keep">
        <div class="card">
            <div class="card-image">
                <figure class="image is-3by1">
                    <img src="https://placeimg.com/1500/500/tech" alt="Image">
                </figure>
            </div>
            <div class="card-content">
                <div class="content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.
                </div>
            </div>
        </div>
    </b-modal>


</div>

</template>

<script>

export default {
    name: 'app',
    data() {
        return {
            isHelpModalActive: false
        }
    }
}

</script>
